import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useClickOutside } from '../../utils/func';

/**
 * Modern PopoverHelper component using React hooks
 * Compatible with React 17+ and provides better click-outside handling
 * @returns {JSX.Element} The popover helper component
 */
const PopoverHelperV2 = ({ id, show, closePopover, className, children }) => {
	const popoverRef = useRef(null);

	useClickOutside(popoverRef, () => {
		if (show) {
			closePopover(id);
		}
	}, [show, id]);

	return (
		<div
			id={id}
			ref={popoverRef}
			className={cx('popover-helper', {'display-none': !show}, className)}
		>
			{React.Children.toArray(children)}
		</div>
	);
};

PopoverHelperV2.propTypes = {
	id: PropTypes.string.isRequired,
	show: PropTypes.bool.isRequired,
	closePopover: PropTypes.func.isRequired,
	className: PropTypes.string,
	children: PropTypes.node
};

export default PopoverHelperV2;
